import React from 'react';
import classNames from 'classnames';
import './ScaleRadioButton.scss';
    
const ScaleRadioButton = (props) => {
    const scaleLabelClasses = classNames('scales__label', {
        'checked': props.isChecked
    });

    return (
        <label
            className={scaleLabelClasses}
            htmlFor={props.radioButtonId}
            title={props.scaleRatingLabel}
        >
            <input
                checked={props.isChecked}
                className='scales__input'
                id={props.radioButtonId}
                name='rating'
                onChange={props.onChange}
                type='radio'
                value={props.scaleValue}
            />
            <span className='scales__label__text'>
                {props.scaleRatingLabel}
            </span>
        </label>
    );
};

export default ScaleRadioButton;



// WEBPACK FOOTER //
// ./application/components/ScaleRadioButton/ScaleRadioButton.jsx